import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import ndSend from "../../../images/nd-send.svg";
import styles from "./send-button.cssmodule.scss";

const SendButton = ({ colour, classname, onClick, altText, disabled }) => {
  const onKeyPress = e => {
    if (e.key === "Enter" && !disabled) {
      onClick();
    }
  };

  return (
    <button
      className={cx(classname, {
        [styles.ndSendButtonContainer]: true,
        disabled,
      })}
      onClick={onClick}
      onKeyPress={onKeyPress}
      data-test="send-button"
      title={altText}
      aria-label={altText}
      style={{ backgroundColor: colour }}
      disabled={disabled}
      type="button"
    >
      <img src={ndSend} alt="send-message" />
    </button>
  );
};

SendButton.propTypes = {
  classname: PropTypes.string,
  colour: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  altText: PropTypes.string,
  disabled: PropTypes.bool,
};

SendButton.defaultProps = {
  colour: "#56535f",
};

export default SendButton;
